






















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';

@Component({})
export default class NormalDialog extends Vue {
  @Prop({})
  private name!: string;
  @Prop({default: '340px'})
  private width!: string | number;
  @Prop({})
  private title!: string;
  @Prop({default: '340px'})
  private height!: string | number;
  @Prop({default: true})
  private resizable!: boolean;

  @Prop({
    default: () => () => {
      return;
    },
  })
  private onShow!: () => void;

  @Emit('before-open')
  private beforeOpen() {
    // do nothing
  }

  private opened() {
    this.onShow();
  }
}
